import { ReactElement } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Accueil from '../Home/Accueil'
import MovePayement from '../MovePayment/MovePayment'
import AddPayment from '../AddPayment/AddPayment'
import Profile from '../Profile/Profile'
import Calendar from '../Payement Calendar/Calendar'
import RetardedPayement from '../Home/RetardedPayement'
import ContactUsContainer from '../ContactUs/ContactUsContainer'
import Loan from '../Loan/Loan'

const TopLevelRoutes = (): ReactElement => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="/home" element={<Accueil />} />
      <Route path="/home/:id" element={<Accueil />} />
      <Route path="/loan-status/:id" element={<Loan />} />
      <Route path="/loan-status" element={<Loan />} />
      <Route path="/move-payement/:id" element={<MovePayement />} />
      <Route path="/move-payement" element={<MovePayement />} />
      <Route path="/add-payment" element={<AddPayment />} />
      <Route path="/add-payment/:id" element={<AddPayment />} />
      <Route path="/delayed-payment/:id/:numPayments" element={<RetardedPayement />} />
      <Route path="/contact-us" element={<ContactUsContainer />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/calendar/:id" element={<Calendar />} />
      <Route path="/calendar" element={<Calendar />} />
    </Routes>
  )
}

export default TopLevelRoutes
